import { useState } from 'react';
import axios from 'axios';

const useFetchProjectPurchaseOrders = () => {
  const [loadingFetchProjectPurchaseOrders, setFetchProjectPurchaseOrders] = useState(false);
  const [errorloadingFetchProjectPurchaseOrders, setErrorFetchProjectPurchaseOrders] = useState(null);

  const fetchProjectPurchaseOrders = async (afeNumber, signal) => {
    try {
      const response = await axios.get(`/api/LandingWarehouse/Netsuite/PurchaseOrders/${afeNumber}`, {
        signal,
      });
      return response.data;
    } catch (err) {
      if (axios.isCancel(err)) console.log('Request canceled');
      throw err;
    }
  };

  return { fetchProjectPurchaseOrders, loadingFetchProjectPurchaseOrders, errorloadingFetchProjectPurchaseOrders };
};

export default useFetchProjectPurchaseOrders;
